import React, { useEffect } from 'react';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';
import { Paragraph } from '@mos-cat/typography';
import { t, Trans } from '@lingui/macro';
import Message, { THEME } from '@mos-cat/message';

import { isAddressNewMoscowWarningVisible } from '../../../../selectors/addressUnmodeled';
import Link from '../../Link/Link';
import { i18n } from '../../../../helpers/i18n';
import { addressValidationError, sendStats } from '../../../../helpers/stats';
import './style.pcss';

interface Props {
  isVisible: boolean;
}

function AddressNewMoscowWarning(props: Props): JSX.Element | null {
  const { isVisible } = props;
  useEffect(() => {
    if (isVisible) sendStats(addressValidationError('manual_input'));
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div>
      <Message theme={THEME.DANGER} className="AddressMessage">
        <Trans>Пожалуйста, проверьте корректность введенного адреса</Trans>
      </Message>
      <Paragraph>
        <Trans>
          Для жителей всех остальных округов Москвы: сообщите в 
          <Link href={i18n._(t`/feedback/support/`)} target="_blank">
            Службу технической поддержки
          </Link>{' '}
          об отсутствии адреса в справочнике. Техподдержка внесет необходимые
          атрибуты вашего адреса в справочник и сообщит вам о возможности подать
          заявление.
        </Trans>
      </Paragraph>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  isVisible: isAddressNewMoscowWarningVisible,
});

export default connect(mapStateToProps)(AddressNewMoscowWarning);
